"use client";

import { useContext } from "react";
import { ActivityFeedColumnsContext } from "./ActivityFeedColumnsProvider";
import { DEFAULT_ACTIVITY_FEED_COLUMNS } from "./constants";
export const useActivityFeedColumns = () => {
  return useContext(ActivityFeedColumnsContext);
};
export const useActivityFeedColumnDelta = (columns, hideCollection) => {
  const columnMap = {
    ...DEFAULT_ACTIVITY_FEED_COLUMNS,
    ...columns,
    hideCollection
  };
  return columnMap;
};